import style from './index.module.scss'
import { useEffect, useRef, useState } from 'react'
import { Rnd } from 'react-rnd'
import { Survey } from '../../types/survey'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedMessage } from 'react-intl'
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons/faCircleQuestion'
import expandBtn from '../../assets/icons/expand.svg'
import closeBtn from '../../assets/icons/close.svg'

const frameHeight = 545
const frameWidth = 550
const delta = 100

interface SurveyFrameProps {
    survey: Survey
    onSurveyFrameClose: () => void
}

export const SurveyFrame = (props: SurveyFrameProps) => {
    const { survey, onSurveyFrameClose } = props
    const ref = useRef<Rnd | null>(null)
    const [position, setPosition] = useState(getFramePosition())
    const [isLoading, setIsLoading] = useState(true)

    const handleClose = () => {
        onSurveyFrameClose()
    }

    function getFramePosition() {
        return {
            x: window.innerWidth - frameWidth - delta,
            y: window.innerHeight - frameHeight - delta,
        }
    }

    useEffect(() => {
        const handleResize = () => {
            setPosition(getFramePosition())
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
        <Rnd
            position={position}
            maxHeight={frameHeight}
            maxWidth={frameWidth}
            enableResizing={false}
            disableDragging={true}
            bounds="window"
            className={style.surveyWindow}
            ref={ref}
        >
            <div className={`modal-header ${style.header}`}>
                <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className={style.question}
                />
                <span style={{ fontWeight: 600 }}>
                    <FormattedMessage id={'homePage.tfbSurvey'} />
                </span>
                <a
                    href={survey.survey_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`ml-auto mr-2 ${style.btn}`}
                >
                    <img
                        src={expandBtn}
                        alt="expand button"
                    />
                </a>
                <button
                    className={`pt-1 ${style.btn}`}
                    onClick={handleClose}
                >
                    <img
                        src={closeBtn}
                        alt="close button"
                    />
                </button>
            </div>

            {isLoading && (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(255, 255, 255, 0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                    }}
                >
                    LOADING...
                </div>
            )}
            <iframe
                src={survey.survey_url}
                width={frameWidth}
                height={frameHeight}
                style={{ padding: '12px 4px' }}
                onLoad={() => setIsLoading(false)}
            />
        </Rnd>
    )
}
